<template>
    <div>

        <b-card  v-if="type == 'text' || type == 'list'" class="h-100 border-0"  align="left" header-bg-variant="white"  footer-bg-variant="white" header-border-variant="white" footer-border-variant="cBorder" body-border-variant="cBorder" :class="type == 'banner'?'bg-transparent p-0':''" border-variant="white" header-class=" text-left" :body-class="`p-0 m-0 rounded  border border-${variant} border-opacity-25`" :footer-class="`border border-${variant} p-0`" :style="type == 'banner'? {} : null ">
            <template v-slot:header v-if="title">
                <b-card-title class="text-dark align-middle m-0  text-left" style="text-align: left;" >
                    <b-img :src="icon" v-bind="{width: 45, height: 45, class: 'm1' }"  alt="Circle image"></b-img>
                    {{title}}
                </b-card-title>
            </template>
            <b-card-body class="p-0  d-none d-sm-block"  v-if="type == 'text' && content">
                <b-row  class="p-0 m-0">
                    <b-col  cols="12" class="p-1 d-flex flex-column">
                        <div class="p-1 bg-info-subtle text-emphasis-info" :style="`background-image: url(${titleImg});line-height:40px;font-size:28px;background-repeat:no-repeat;`">
                            {{content.subText}}
                        </div>
                        <div class="p-3">
                            <p class="text-left h5" v-for="(text,i) in content.textList"> {{text}}</p>
                        </div>
                        
                    </b-col>
                </b-row>
            </b-card-body>
            <b-card-body class="p-0 bg-light  h-100" v-if="type == 'list' && content.length > 0" >
                <b-row  class="p-0 m-0  h-100" >
                    <template  v-for="(list,index) in content">
                        <b-col  class="p-2 m-0" v-if="!(list instanceof Array)"  sm="12"  :md="12 / content.length">
                            <listLayout  :title="list.title" :config="list"></listLayout>
                        </b-col>
                        <b-col  class=" pl-0 m-0  h-100"
                        :class="{ 
                         'pl-0 pt-2 pr-2 pb-2':index == 0 && content.length !== 1,
                        'pl-2 pt-2 pr-0 pb-2' :index == content.length -1 && content.length !== 1, 
                        'pl-2 pt-2 pr-2 pb-2':content.length > 1 && index !== 0 && index !== content.length -1
                        }"
                        v-if="list instanceof Array && list.length > 0"  sm="12"  :md="12 / content.length">
                            <b-row  class="p-0 m-0">
                                <b-col  class="p-0 m-0" :class="i == list.length -1 ? '' : 'pb-2'" v-for="(item,i) in list"  sm="12"  :md="12 * item.row">
                                    <listLayout :title="item.title" :config="item" v-if="item.type == 'list'"></listLayout>
                                    <chartLayout :title="item.title" :config="item" v-if="item.type == 'chart'"></chartLayout>
                                </b-col>
                            </b-row>
                        </b-col>
                    </template>
                    
                </b-row>
            </b-card-body>
            <b-card-body class="p-0 bg-transparent"  v-if="type == 'banner' && content.length > 0" >
                <b-row  class="p-0 m-0">
                    <template  v-for="(list,index) in content">
                        <b-col class="p-0 m-0"  sm="12"  :md="12 / content.length"  v-if="!(list instanceof Array)">
                            <bannerLayout :title="list.title" :config="list" v-if="list.type == 'banner'"></bannerLayout>
                        </b-col>
                        <b-col  sm="12"  :md="12 / content.length" class="pt-3 pb-3 pr-3 pl-0 m-0" :class="index == 1 ? 'pr-0 pl-3' : 'ml-1'"  v-if="list instanceof Array && list.length > 0">
                            <b-row  class="p-0 m-0">
                                <b-col class="p-0 m-0" v-for="(item,i) in list"  sm="12"  :md="12 * item.row">
                                    <bannerLayout :title="item.title" :config="item" v-if="item.type == 'banner'"></bannerLayout>
                                </b-col>
                            </b-row>
                        </b-col>
                    </template>
                    
                </b-row>
            </b-card-body>
        </b-card>
        <b-card v-if="type == 'banner'" class="h-100  border-0  bg-transparent"  align="left" body-class="p-0 m-0  bg-transparent">
            <template v-slot:header v-if="title">
                <b-card-title class="text-dark align-middle m-0  text-left" style="text-align: left;" >
                    <b-img v-bind="{ blank: true, blankColor: '#777', width: 35, height: 35, class: 'm1' }" rounded="circle" alt="Circle image"></b-img>
                    {{title}}
                </b-card-title>
            </template>
            
            <b-card-body class="p-0 bg-transparent   d-none d-sm-block">
                <b-row  class="p-0 m-0" v-if="type == 'banner' && content.length > 0" align-v="center">
                    <template  v-for="(list,index) in content" v-if="!(list instanceof Array)">
                        <b-col :cols="`${12/content.length}`" class="p-0" 
                        :class="{ 
                         'pl-0 pt-2 pr-2 pb-2':index == 0 && content.length !== 1,
                        'pl-2 pt-2 pr-0 pb-2' :index == content.length -1 && content.length !== 1, 
                        'pl-2 pt-2 pr-2 pb-2':content.length > 1 && index !== 0 && index !== content.length -1
                        }">
                            <bannerLayout :type="list.type" :title="list.title" :config="list" v-if="list.type == 'banner'"></bannerLayout>
                        </b-col>
                        <b-col  v-if="list instanceof Array && list.length > 0"  v-for="(item,i) in list">
                            <bannerLayout :type="list.type" :title="item.title" :config="item" v-if="item.type == 'banner'"></bannerLayout>
                        </b-col>
                    </template>
                </b-row>
            </b-card-body>
            <b-card-body class="p-0 bg-transparent   d-block d-sm-none">
                <!-- 小屏幕布局 -->
                <b-row  class="p-0 m-0" v-if="type == 'banner' && content.length > 0" align-v="center">
                    <template  v-for="(list,index) in content" v-if="!(list instanceof Array)">
                        <b-col :cols="`12`" class="p-0 pb-2">
                            <bannerLayout :type="list.type" :title="list.title" :config="list" v-if="list.type == 'banner'"></bannerLayout>
                        </b-col>
                        <b-col  v-if="list instanceof Array && list.length > 0"  v-for="(item,i) in list">
                            <bannerLayout :type="list.type" :title="item.title" :config="item" v-if="item.type == 'banner'"></bannerLayout>
                        </b-col>
                    </template>
                </b-row>
            </b-card-body>
        </b-card>
        <b-card v-if="type == 'cards'" class="h-100  border-0  bg-transparent "  align="center" body-class="p-0 m-0  bg-transparent"  header-class="border-0"  header-bg-variant="transparent">
            <template v-slot:header v-if="title">
                <b-card-title class="text-dark align-middle m-0  text-center" style="text-align: center;" >
                    <!-- <b-img v-bind="{ blank: true, blankColor: '#777', width: 35, height: 35, class: 'm1' }" rounded="circle" alt="Circle image"></b-img> -->
                    {{title}}
                </b-card-title>
            </template>
            
            <b-card-body class="p-0 bg-transparent d-none d-sm-block">
                <b-row  class="p-0 m-0" v-if="type == 'cards' && content.length > 0" >
                    <b-carousel
                        id="carousel-no-animation"
                        style="text-shadow: 0px 0px 2px #000"
                        class="w-100"
                        :interval="3000"
                    >
                        <b-carousel-slide v-for="(list,index) in content" class="w-100  rounded-lg">
                            <!-- 小屏幕布局 -->
                            <template  v-slot:img >
                                <b-row >
                                    <template  v-for="(list,index) in content">
                                        <b-col  class="p-1 m-0"  sm="12"  :md=" content.length > 2 ? 2 : 12 / content.length"  v-if="!(list instanceof Array)">
                                            <bannerLayout :title="list.title" :type="list.type" :config="list" v-if="list.type == 'cards'"></bannerLayout>
                                        </b-col>
                                        <b-col  class="pt-3 pb-3 pr-3 pl-0 m-0  " sm="12"  :md="12 / content.length"  v-if="list instanceof Array && list.length > 0">
                                            <b-row  class="p-0 m-0">
                                                <b-col  class="p-0"  sm="12"  :md="list.length > 2 ? 2 : 12 * item.row" v-for="(item,i) in list">
                                                    <bannerLayout  :type="list.type" :title="item.title" :config="item" v-if="item.type == 'cards'"></bannerLayout>
                                                </b-col>
                                            </b-row>
                                        </b-col>
                                    </template>
                                
                                </b-row>
                            </template>
                        </b-carousel-slide>
                    </b-carousel>
                    
                </b-row>
            </b-card-body>
            <b-card-body class="p-0 bg-transparent d-block d-sm-none">
                <b-row  class="p-0 m-0" v-if="type == 'cards' && content.length > 0" >
                    <b-carousel
                        id="carousel-no-animation"
                        style="text-shadow: 0px 0px 2px #000"
                        :no-hover-pause="true"
                        class="w-100"
                        :interval="3000"
                    >
                        <b-carousel-slide v-for="(list,index) in content" class="w-100    rounded-lg "  >
                            <template  v-slot:img >
                                <b-row >
                                    <template  >
                                        <b-col  class="p-1 m-0"  sm="12"  :md=" content.length > 2 ? 2 : 12 / content.length"  v-if="!(list instanceof Array)"  >
                                            <bannerLayout :title="list.title" :type="list.type" :config="list" v-if="list.type == 'cards'"></bannerLayout>
                                        </b-col>
                                        <b-col  class="pt-3 pb-3 pr-3 pl-0 m-0 " sm="12"  :md="12 / content.length"  v-if="list instanceof Array && list.length > 0">
                                            <b-row  class="p-0 m-0">
                                                <b-col  class="p-0"  sm="12"  :md="list.length > 2 ? 2 : 12 * item.row" v-for="(item,i) in list" >
                                                    <bannerLayout  :type="list.type"  :title="item.title" :config="item" v-if="item.type == 'cards'"></bannerLayout>
                                                </b-col>
                                            </b-row>
                                        </b-col>
                                    </template>
                                
                                </b-row>
                                
                            </template>
                        </b-carousel-slide>
                        <!-- <b-carousel-slide v-for="(list,index) in content" class="w-100">
                            <template  v-slot:img >
                                <b-row >
                                    <template >
                                        <b-col :cols="`12`" class="p-0 pb-2">
                                            <bannerLayout :type="list.type" :title="list.title" :config="list" v-if="list.type == 'banner'"></bannerLayout>
                                        </b-col>
                                    </template>
                                </b-row>
                            </template>
                        </b-carousel-slide> -->
                    </b-carousel>
                    
                </b-row>
            </b-card-body>
        </b-card>
    </div>
    
  </template>
  
  <script>
  import mapTitleImg from '@/assets/mapTitle.png'

  import listLayout from '@/components/listLayout.vue'
  import chartLayout from '@/components/chartLayout.vue'
  import bannerLayout from '@/components/bannerLayout.vue'
  export default {
    name: 'Layout-unit',
    components:{listLayout,chartLayout,bannerLayout},
    props: {
        navs: {
            type:Array,
            default(){
                return []
            }
        },
        brand:{
            type:Object,
            default(){
                return null
            }
        },
        variant:{
            type:String,
            default(){
                return 'primary'
            }
        },
        icon:{
            type:String,
            default(){
                return 'primary'
            }
        },
        type:{
            type:String,
            default(){
                return 'text'  // text   map   list
            }
        },
        content:{
            type:[Object,Array],
            default(){
                return null
             
            }
        },
        title:{
            type:String,
            default(){
                return ''
            }
        }
    },
    mounted(){
        this.getEchartData()  
    },
    data() {
      return {
        titleImg:mapTitleImg,
        provinceName:""
      }
    },
      methods: {
        getEchartData() {
            
        },
        getEchartProvinceData(province) {
           
            
        }
    }
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>

  </style>
  